import { SEARCH_DNO_FAILURE, SEARCH_DNO_REQUEST, SEARCH_DNO_RESET, SEARCH_DNO_SUCCESS } from "redux/actions/action-type"


const initialState = {
    isSearchLoading: false,
    isSearchSuccess: false,
    isSearchFail: false,
    searchDNOResponse: {}
}

export const searchDoNotOrderListReducer = (state = initialState, { type, searchDNOResponse }) => {
    switch (type) {
        case SEARCH_DNO_REQUEST:            
            return {
                ...state,
                isSearchLoading: true,
                isSearchSuccess: false,
                isSearchFail: false
            }
        case SEARCH_DNO_SUCCESS:
            return {
                ...state,
                searchDNOResponse: searchDNOResponse,
                isSearchLoading: false,
                isSearchSuccess: true,
                isSearchFail: false
            }
        case SEARCH_DNO_FAILURE:
            return {
                ...state,
                searchDNOResponse: searchDNOResponse,
                isSearchLoading: false,
                isSearchSuccess: false,
                isSearchFail: true
            }
        case SEARCH_DNO_RESET:
            return {
                ...initialState
            }
        default:
            return {
                ...state
            }
    }
}